import { useState, useContext } from 'react';
import { AppContext } from '../AppContext';

function SettingsPanel() {
  const { openAIApiKey: openAIKey, setOpenAIApiKey: setOpenAIKey, assemblyAIApiKey, setAssemblyAIApiKey: setAssemblyAIKey } = useContext(AppContext);

  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    // Implement your save logic here (e.g., localStorage, API call)
    console.log('OpenAI Key:', openAIKey);
    console.log('AssemblyAI Key:', assemblyAIApiKey);

    setSaved(true);
    setTimeout(() => setSaved(false), 2000); // Reset saved notification
  };

  return (
    <div className="w-full max-w-2xl bg-white p-6 rounded shadow-md">
      <h2 className="text-2xl font-bold mb-4 text-center">⚙️ Application Settings</h2>

      {/* AssemblyAI Key Input */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-1" htmlFor="assemblyAIKey">
          <b>AssemblyAI</b> API Key
        </label>
        <input
          type="password"
          id="assemblyAIKey"
          value={assemblyAIApiKey}
          onChange={(e) => setAssemblyAIKey(e.target.value)}
          className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter your AssemblyAI API key"
        />
      </div>

      {/* OpenAI Key Input */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-1" htmlFor="openAIKey">
          <b>OpenAI</b> API Key
        </label>
        <input
          type="password"
          id="openAIKey"
          value={openAIKey}
          onChange={(e) => setOpenAIKey(e.target.value)}
          className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter your OpenAI API key"
        />
      </div>
      {/* Save Button */}
      <button
        onClick={handleSave}
        className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        Save Settings
      </button>

      {/* Notification */}
      {saved && (
        <div className="mt-4 text-green-600 font-semibold text-center">
          Settings saved successfully!
        </div>
      )}
    </div>
  );
}

export default SettingsPanel;